import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";
import {
  ref,
} from "vue";
import {
  WebchargeSettings,
} from "@/components/settings/scripts/Webcharge";
import {
  HelperFunctions,
} from "@/scripts/Common/HelperFunctions";
import {
  Constants,
} from "@/scripts/Common/Constants";
import {getToken} from "@/scripts/Common";

const webchargeSettings = ref<WebchargeSettings>({
  hasSpecificChargingDays: false,
  chargingDays: []
});

const responseError = ref<any>();

const loadConfiguredWebcharges = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'webchargeConfiguration',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
    }
  });

  webchargeSettings.value = response;
  responseError.value = error;
}

const getEnabledDates = (val: string) => {
  //parseInt to cut leading zeros this is needed see Vuetify docs: https://vuetifyjs.com/en/components/date-pickers/
  // section allowed-dates
  const splitDate = val.split('-');
  const day = Number.parseInt(splitDate[2], 10);
  const month = Number.parseInt(splitDate[1], 10);
  const year = Number.parseInt(splitDate[0], 10);

  if (!webchargeSettings.value.hasSpecificChargingDays) {
    return true;
  }

  return webchargeSettings.value.chargingDays?.includes(day.toString())
    || (webchargeSettings.value.chargingDays?.includes(Constants.ULTIMO) &&
      HelperFunctions.getLastDayOfMonth(year, month) === day);
}

const useWebchargeSettings = () => {

  loadConfiguredWebcharges();

  return {
    webchargeSettings,
    error: responseError,
    getEnabledDates
  }
}



export {
  useWebchargeSettings
}

